<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>Projekte Light</h3>
</div>

<div class="row filter-row mb-3" *ngIf="stats">
    <div class="col">
        <div class="card card-stats">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <p (click)="setFilterStatus(['Offen'])" class="bg-dark"><span>{{ stats.Offen }}</span> Offen</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['In Arbeit'])" class="bg-info"><span>{{ stats['In Arbeit'] }}</span> In Arbeit</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['Erledigt'])" class="bg-danger"><span>{{ stats.Erledigt }}</span> Erledigt</p>
                    </div>
                    <div class="col">
                        <p (click)="setFilterStatus(['On Hold'])" class="bg-warning text-dark" style="background: #ffff08;"><span>{{ stats['On Hold'] }}</span> On Hold</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <h5 class="card-header">
        {{ totalProjects }} Projekte
        <button type="button" class="btn btn-primary btn-sm ms-1" [routerLink]="['/light/detail', 0]"><i class="fas fa-plus"></i> Neues Projekt</button>

        <pagination class="float-end mb-0" style="font-size: 1rem"
                    [hidden]="projects.length === 0"
                    [totalItems]="totalProjects"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="loadProjects($event)"
                    [maxSize]="10"
                    previousText="Zurück"
                    nextText="Weiter"
        />
        <button type="button" class="btn btn-secondary btn-sm float-end me-2" (click)="resetFilterAndReload()">Filter zurücksetzen</button>
        <button type="button" class="btn btn-secondary btn-sm float-end me-2"
                [disabled]="exporting || totalProjects === 0"
                (click)="exportProjects()">Export Excel
        </button>
        <div class="form-check float-end me-2" style="font-size: 0.875rem; position: relative; top: 5px">
            <input class="form-check-input" type="checkbox" [(ngModel)]="filter.showPast" (ngModelChange)="loadProjects(paginConfig)">
            <label class="form-check-label fw-normal">
                Nur laufende Projekte anzeigen
            </label>
        </div>
    </h5>
    <div class="card-body">

        <div class="table-responsive">
            <table class="table table-hover table-striped table-sm table-new mb-0">
                <thead>
                <tr>
                    <th>
                        <input type="text" class="form-control form-control-sm" name="number" appDebounceKeyup (debounceKeyup)="loadProjects(paginConfig)" [(ngModel)]="filter.number" [class.is-filtered]="filter.number !== ''">
                    </th>
                    <th></th>
                    <th>
                        <button type="button" class="btn btn-secondary btn-sm" style="width: 100%"
                                [class.is-filtered]="filter.status.length > 0"
                                [popover]="popTemplate"
                                [outsideClick]="true" popoverTitle="Auswahl Status">
                            {{filter.status.length}} Filter aktiv
                        </button>
                    </th>
                    <th>
                        <input type="text" class="form-control form-control-sm" name="title" appDebounceKeyup (debounceKeyup)="loadProjects(paginConfig)" [(ngModel)]="filter.title" [class.is-filtered]="filter.title !== ''">
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_region" [(ngModel)]="filter.id_region" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_region !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let region of regions" [value]="region.id">Region {{ region.region }} ({{ region.countries }})</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_country" [(ngModel)]="filter.id_country" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_country !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let country of countries" [value]="country.short">{{ country.short }}</option>
                        </select>
                    </th>
                    <th>
                        <input type="text" class="form-control form-control-sm" name="lead" appDebounceKeyup (debounceKeyup)="loadProjects(paginConfig)" [(ngModel)]="filter.lead" [class.is-filtered]="filter.lead !== ''">
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="id_department" [(ngModel)]="filter.id_department" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.id_department !== 'all'">
                            <option value="all">Alle</option>
                            <option *ngFor="let department of departments" [value]="department.id">{{ department.name }} ({{ department.lead }})</option>
                        </select>
                    </th>
                    <th>
                        <select class="form-control form-control-sm" name="milestones" [(ngModel)]="filter.update" (ngModelChange)="loadProjects(paginConfig)" [class.is-filtered]="filter.update !== 'all'">
                            <option value="all">Alle</option>
                            <option value="Grün">Erfüllt</option>
                            <option value="Gelb">Teilweise erfüllt</option>
                            <option value="Rot">Nicht erfüllt</option>
                        </select>
                    </th>
                    <th></th>
                </tr>
                <tr>
                    <th (click)="setOrder('number')">Nummer <i *ngIf="filter.order === 'number'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i></th>
                    <th (click)="setOrder('start')">Projektstart <i *ngIf="filter.order === 'start'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i></th>
                    <th class="no-pointer">Status</th>
                    <th class="no-pointer">Titel</th>
                    <th (click)="setOrder('id_region')" style="min-width: 50px">Länderbereich <i *ngIf="filter.order === 'id_region'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i></th>
                    <th class="no-pointer">Länder</th>
                    <th (click)="setOrder('lead')">Projektleiter <i *ngIf="filter.order === 'lead'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i></th>
                    <th (click)="setOrder('id_department')">Abteilung <i *ngIf="filter.order === 'id_department'" class="fa" [ngClass]="{'fa-arrow-down': filter.reverse, 'fa-arrow-up': !filter.reverse}"></i></th>
                    <th class="no-pointer">Statusupdate</th>
                    <th class="no-pointer">Letztes Statusupdate</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let project of projects" [class.is-highlighted]="project.id === highlightedRow" (click)="highlightRow(project.id)" [routerLink]="['/light/detail', project.id]">
                    <td>PRL{{ project.number | number: '3.0' }}</td>
                    <td>{{ project.start | date: 'dd.MM.yyyy' }}</td>
                    <td>{{ project.status }}</td>
                    <td>{{ project.title }}</td>
                    <td>{{ project.region }}</td>
                    <td>{{ project.countries }}</td>
                    <td>{{ project.lead }}</td>
                    <td>{{ project.department }}</td>
                    <td>
                        <i class="fa-solid fa-circle"
                           *ngIf="project.status_report"
                           [ngClass]="{'text-success': project.status_report?.color === 'Grün', 'text-warning': project.status_report?.color === 'Gelb', 'text-danger': project.status_report?.color === 'Rot'}">
                        </i>
                    </td>
                    <td>{{ project.status_report?.created_at | date: 'dd.MM.yyyy' }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #popTemplate>
    <select class="form-control form-control-sm" name="status" size="4" multiple [(ngModel)]="filter.status" (ngModelChange)="loadProjects(paginConfig)">
        <option *ngFor="let status of LightStatus | keyvalue: asIsOrder" [value]="status.value">{{ status.value }}</option>
    </select>
</ng-template>
